

<section class="d-flex align-items-center justify-content-center min-vh-100" id="myBody">
  <main class="text-center fade-in px-3 py-4">
    <!-- Animación -->
    <div class="mb-4">
      <iframe width="100%" height="320"
        src="https://lottie.host/embed/9f1183ec-4427-4195-b1c2-9f34ff6bec59/XKi8H39F9T.json" frameborder="0"
        title="Animación de error" aria-label="Animación representando un error o página no encontrada" class="rounded">
      </iframe>
    </div>

    <!-- Mensaje de error -->
    <header>
      <p class="fs-3">
        <span class="text-danger fw-bold">¡Ups!</span> Página no encontrada.
      </p>
      <p class="lead fw-semibold">
        Parece que ha habido un error con la página que estabas buscando.<br>
        Es posible que haya sido eliminada o la dirección no exista.
      </p>
    </header>

    <hr class="my-4">

    <!-- Trámite sugerido -->
    <div>
      <h4 class="fw-semibold mb-3">Certificado de no Infracción</h4>
      <button mat-flat-button class="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2 text-white"
        (click)="openLink('https://af-oficina-virtual.sefintlax.gob.mx/ventanilla-unica')">
        <mat-icon>edit</mat-icon>
        IR AL TRÁMITE
      </button>
    </div>

  </main>
</section>
